<template>
  <div class="content-wrapper" :class="{'cross-content': !$store.state.sharePresentation}">
    <div class="horizontal layout center-justified" style="height: 100%" v-if="checkShowContent()">
      <QaSession />
    </div>
    <CanvasQuestionImage
      v-show="slideActive.showQuestionImage && slideActive.image"
      @imageLoaded="isLoading = false"
      :isLoading="isLoading"
    />
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import QaSession from '@/components/presentations/QaSession'
import CanvasQuestionImage from '@/components-v2/presentation-editor/middle/CanvasQuestionImage.vue'

export default {
  components: {
    QaSession,
    CanvasQuestionImage,
  },
  data() {
    return {
      isLoading: false,
    }
  },
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
    }),
  },
  mounted() {
    this.$store.state.showQnaSession = false
    if (this.$store.state.sharePresentation) {
      this.updateSlideActiveAction({
        showQuestionImage: false,
      })
    }
  },

  methods: {
    ...mapActions(['updateSlideActiveAction']),
    checkShowContent() {
      let show = true
      if (this.$store.state.slideActive.showQuestionImage && this.$store.state.slideActive.image) {
        show = false
      }
      return show
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";
.content-wrapper {
  width: 100%;
  height: 100%;
  &.cross-content {
    &::v-deep text:hover {
      text-decoration: line-through;
      cursor: pointer;
    }
  }
}
</style>
